import React from 'react';

import PropTypes from 'prop-types';

export type License = {
  type: string;
  productType: string;
};

export type Product = {
  name: string;
  key: string;
};

export type ProductV2 = {
  productName: string;
  productKey: string;
};

export type Offering = {
  daysRemaining: number;
  expirationDate: string;
  offeringCategory: string;
  offeringCategoryName: string;
  offeringCategoryRanking: number;
  offeringExternalKey: string;
  offeringName?: string;
  products: Product[];
  status: string;
  type: string;
};

export type Subscription = {
  daysRemaining: number;
  endDate: string;
  offeringCategory: string;
  offeringCategoryName: string;
  offeringCategoryRanking: number;
  offeringExternalKey: string;
  offeringName: string;
  products: ProductV2[];
  status: string;
  type: string;
};

export type User = {
  id: string;
  email: string;
  licenses?: License[] | null;
  analyticsId?: string | null;
};

export type BannerMessage = {
  text: React.ReactNode;
  daysLeft: number;
};

export const productsPropType = PropTypes.shape({
  name: PropTypes.string.isRequired,
  key: PropTypes.string.isRequired,
});

export const offeringPropType = PropTypes.shape({
  daysRemaining: PropTypes.number.isRequired,
  expirationDate: PropTypes.string.isRequired,
  offeringCategory: PropTypes.string.isRequired,
  offeringCategoryName: PropTypes.string.isRequired,
  offeringCategoryRanking: PropTypes.number.isRequired,
  offeringExternalKey: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  products: PropTypes.arrayOf(productsPropType.isRequired).isRequired,
});

export const licensePropType = PropTypes.shape({
  type: PropTypes.string.isRequired,
  productType: PropTypes.string.isRequired,
});

export const userPropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  licenses: PropTypes.arrayOf(licensePropType.isRequired),
  analyticsId: PropTypes.string,
});

export const bannerMessagePropType = PropTypes.shape({
  text: PropTypes.string.isRequired,
  daysLeft: PropTypes.number.isRequired,
});
